import script from "./MultiVideosHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./MultiVideosHeader.vue?vue&type=script&lang=ts&setup=true"

import "./MultiVideosHeader.vue?vue&type=style&index=0&id=38ce4c94&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38ce4c94"]])

export default __exports__